import React, { useEffect, useMemo, useState } from "react";
import Multi from "./Multi";
import { usePageType } from "../ChartApp";
const MultiSelect = ({ id, options, setOptionsSelected, multiSelects, setMultiSelects, resetMulti, setResetMulti, isMulti, setIsMultiArray, area, setArea, }) => {
    const [currentOptionsArray, setCurrentOptionsArray] = useState([]);
    const pageType = usePageType();
    const handleChange = (selected, id) => {
        let arrayOfSelectedFilters = multiSelects;
        if (selected.length === 1 && Object.keys(multiSelects).length === 0) {
            arrayOfSelectedFilters[id] = selected.map((e) => {
                return e;
            });
        }
        else if (selected.length > 1 && arrayOfSelectedFilters[id]) {
            arrayOfSelectedFilters[id] = selected;
        }
        else if (Object.keys(multiSelects).length != 0 &&
            multiSelects[id] === undefined) {
            if (pageType === "social_data" && multiSelects["year"] !== undefined) {
                arrayOfSelectedFilters = {
                    area: selected,
                    year: [],
                };
            }
            arrayOfSelectedFilters[id] = selected.map((e) => {
                return e;
            });
        }
        else if (Object.keys(multiSelects).length != 0 &&
            multiSelects[id] != undefined) {
            if (id === "area" && pageType === "social_data") {
                arrayOfSelectedFilters = {
                    area: selected,
                    year: [],
                };
            }
            else {
                arrayOfSelectedFilters[id] = selected.map((e) => {
                    return e;
                });
            }
        }
        setOptionsSelected(selected);
        setCurrentOptionsArray(selected);
        setMultiSelects(arrayOfSelectedFilters);
    };
    const optionsMe = useMemo(() => options.values.map((option) => ({
        value: option.key,
        label: option.value,
    })), [options.values]);
    useEffect(() => {
        setCurrentOptionsArray([]);
    }, [resetMulti]);
    useEffect(() => {
        if (id === "year") {
            setCurrentOptionsArray([]);
        }
    }, [area]);
    return (React.createElement("div", { className: "multiSelect" },
        React.createElement("label", { className: "fw-bold" }, options.filter),
        React.createElement("div", { className: "choices" },
            React.createElement(Multi, { id: id, options: optionsMe, value: currentOptionsArray, onChange: handleChange, isSelectAll: true, menuPlacement: "bottom", isMulti: isMulti, setIsMultiArray: setIsMultiArray, setArea: setArea, setResetMulti: setResetMulti }))));
};
export default MultiSelect;
